import * as React from "react";

function Excel(props) {
  return (
    <svg
      width="30"
      height="32"
      viewBox="0 0 30 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.854 2.176L21.894 0H6.45881C5.34521 0 4.91481 0.8256 4.91481 1.4704V7.2784H7.07961V2.6448C7.07961 2.3984 7.28761 2.1904 7.52761 2.1904H18.5724C18.8156 2.1904 18.9372 2.2336 18.9372 2.4336V10.1456H26.798C27.1068 10.1456 27.2268 10.3056 27.2268 10.5392V29.3712C27.2268 29.7648 27.0668 29.824 26.8268 29.824H7.52761C7.4086 29.8211 7.29537 29.7721 7.21179 29.6873C7.12821 29.6026 7.08082 29.4886 7.07961 29.3696V27.648H4.92921V30.36C4.90041 31.32 5.41241 32 6.45881 32H27.8956C29.0156 32 29.398 31.1888 29.398 30.4496V8.2992L28.838 7.6912L23.8524 2.1776L23.854 2.176ZM21.1372 2.432L21.7564 3.1264L25.91 7.6912L26.1388 7.968H21.894C21.574 7.968 21.3708 7.9152 21.286 7.808C21.2012 7.704 21.1516 7.536 21.1372 7.3072V2.432ZM19.3932 17.0672H26.7164V19.2016H19.3916V17.0672H19.3932ZM19.3932 12.8016H26.7164V14.9344H19.3916V12.8L19.3932 12.8016ZM19.3932 21.3344H26.7164V23.4688H19.3916V21.3344H19.3932ZM0.599609 9.0016V26.0688H17.3436V9.0016H0.599609ZM8.97241 18.928L7.94841 20.4928H8.97241V22.4H3.82521L7.55961 16.784L4.25081 11.7344H7.01561L8.97401 14.672L10.9308 11.7344H13.694L10.3788 16.784L14.118 22.4H11.2492L8.97241 18.928Z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoExcel = React.memo(Excel);
export default MemoExcel;
